<div header="Update User Data" class="align-items-center">
  <div class="col-12 mb-3 p-0">
      <div class="w-full flex flex-column gap-3 pb-3">
          <div class="flex gap-1">
              {{'Check any values you’d like to add' | sentenceCase}}:
          </div>
      </div>
      <div class="flex">
        <p-checkbox inputId="secondaryRate" [(ngModel)]="value" [binary]="true"></p-checkbox>
        <label for="secondaryRate" class="ml-2">Add a secondary rate</label>
      </div>
  </div>
  <div class="flex justify-content-end gap-2 mt-3">
    <p-button label="cancel" [outlined]="true" [rounded]="true" (click)="onCancel()"></p-button>
    <p-button label="save" [rounded]="true" size="small" (click)="onSave()"></p-button>
  </div>
</div>